export default __webpack_public_path__ + "static/146-b9d6fb3f00932b30f96fb6a11fffcf30.jpg";